import { render } from "./ConsultantLabelPicker.vue?vue&type=template&id=446c07db"
import script from "./ConsultantLabelPicker.vue?vue&type=script&lang=js"
export * from "./ConsultantLabelPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__